import { actionTypes, reducers, sagas } from 'data'
import { applyMiddleware, compose, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'
import isProd from 'utils/isProd'

import logVersion from './logVersion'

const devToolsConfig = {
  actionsBlacklist: [actionTypes.trades.SET_UPDATE, actionTypes.ticker.SET_UPDATE],
  maxAge: 10000
}

logVersion()

const sagaMiddleware = createSagaMiddleware()

const composeEnhancers = !isProd() ? composeWithDevTools(devToolsConfig) : compose

export default () => {
  const store = createStore(reducers, undefined, composeEnhancers(applyMiddleware(sagaMiddleware)))
  sagaMiddleware.run(sagas).toPromise()

  return store
}
